// extracted by mini-css-extract-plugin
module.exports = {"Root__Navigation":"Header_Root__Navigation__4YGkj","Root__NavigationMobile":"Header_Root__NavigationMobile__nBVt8"};